var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-3"},[_c('vue-editor',{attrs:{"height":"250","placeholder":_vm.$t('job.form.summary.placeholder')},model:{value:(_vm.model.note),callback:function ($$v) {_vm.$set(_vm.model, "note", $$v)},expression:"model.note"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }